module.exports = __webpack_public_path__ + "static/media/choptank.3cfffcc3.png";